import {get, post} from '../router/http.js'


export default {
	info :(params) => {
		return get('/api/user/info', params)
	},
    getErrorQuestionList :(params) => {
        return get('/api/user/error/question', params)
    },
    getStrangeWord :(params) => {
        return get('/api/user/strange/word', params)
    },
    getErrorWord :(params) => {
        return get('/api/user/error/word', params)
    },

}



// WEBPACK FOOTER //
// ./src/api/user.js